module.exports = __webpack_public_path__ + "img/service_icon.eb49009d.png";